import Route from '@ember/routing/route';

export default class UploadRoute extends Route {
  model() {
    return null;
  }
}
